export const REQUESTED_FIELDS_FROM_VINTELLIGENCE = [
  'MAK_CD',
  'MAK_NM',
  'MDL_YR',
  'MDL_CD',
  'MDL_DESC',
  'SHIP_WGHT_LBS',
  'TRIM_DESC',
  'NADA_MSRP1',
  'NADA_GVWC1',
  'NADA_GCW1',
  'BODY_STYLE_CD',
  'BODY_STYLE_DESC',
  'VEH_TYP_CD',
  'VEH_TYP_DESC',
].join(',');
